export default __webpack_public_path__ + "8216ea27b618ea41e574f2504f092046.png";